import { createReducer, on } from '@ngrx/store';
import { Transaction } from '../../models/transaction.interface';
import {
  loadTransactionsFailure,
  loadTransactionsSuccess,
  resetTransactionHistoryState,
  toggleTransactionsLoading,
} from '../actions/transaction-history.actions';

export interface TransactionHistoryState {
  transactionsLoading: boolean;
  transactionsFilter: { [key: string]: any };
  transactions: Transaction[];
  totalTransactions: number;
  totalFailedTransactions: number;
  successRate: number;
  totalThisMonth: number;
  totalThisWeek: number;
  totalToday: number;
  monthOverMonthChange: number;
}

export const transactionsHistoryInitialState: TransactionHistoryState = {
  transactionsLoading: false,
  transactionsFilter: null,
  transactions: [],
  totalTransactions: 0,
  totalFailedTransactions: 0,
  successRate: 0,
  totalThisMonth: 0,
  totalThisWeek: 0,
  totalToday: 0,
  monthOverMonthChange: 0,
};

const _transactionsHistoryReducer = createReducer(
  transactionsHistoryInitialState,
  on(toggleTransactionsLoading, (state, { transactionsLoading }) => ({
    ...state,
    transactionsLoading,
  })),
  on(
    loadTransactionsSuccess,
    (
      state,
      {
        transactions,
        totalTransactions,
        totalFailedTransactions,
        successRate,
        totalThisMonth,
        totalThisWeek,
        totalToday,
        monthOverMonthChange,
      },
    ) => ({
      ...state,
      transactions,
      totalTransactions,
      totalFailedTransactions,
      successRate,
      totalThisMonth,
      totalThisWeek,
      totalToday,
      monthOverMonthChange,
    }),
  ),
  on(loadTransactionsFailure, (state) => ({
    ...state,
    transactions: transactionsHistoryInitialState.transactions,
    totalTransactions: transactionsHistoryInitialState.totalTransactions,
    totalFailedTransactions: transactionsHistoryInitialState.totalFailedTransactions,
    SuccessRate: transactionsHistoryInitialState.successRate,
    TotalThisMonth: transactionsHistoryInitialState.totalThisMonth,
    TotalThisWeek: transactionsHistoryInitialState.totalThisWeek,
    TotalToday: transactionsHistoryInitialState.totalToday,
    monthOverMonthChange: transactionsHistoryInitialState.monthOverMonthChange,
  })),
  on(resetTransactionHistoryState, (state, { saveFilter, filter }) => ({
    ...transactionsHistoryInitialState,
    transactionsFilter: saveFilter ? filter : transactionsHistoryInitialState.transactionsFilter,
  })),
);

export function transactionsHistoryReducer(state, action) {
  return _transactionsHistoryReducer(state, action);
}
